var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleBuss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 242.595,
    height: 83.127,
    viewBox: "0 0 242.595 83.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(0 -1057.818)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 242.595,
    height: 83.127,
    rx: 8,
    transform: "translate(0 1057.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Google-travel-logo",
    transform: "translate(31.56 1074.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M135,71.937a10.426,10.426,0,1,1-10.426-10.393A10.265,10.265,0,0,1,135,71.937Zm-4.564,0a5.877,5.877,0,1,0-5.862,6.3A5.985,5.985,0,0,0,130.439,71.937Z",
    transform: "translate(-42.672 -42.749)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M166.767,71.937a10.426,10.426,0,1,1-10.426-10.393A10.265,10.265,0,0,1,166.767,71.937Zm-4.564,0a5.877,5.877,0,1,0-5.861,6.3A5.985,5.985,0,0,0,162.2,71.937Z",
    transform: "translate(-51.945 -42.749)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M197.591,62.172V80.831c0,7.675-4.526,10.81-9.878,10.81a9.9,9.9,0,0,1-9.212-6.124l3.974-1.654a5.74,5.74,0,0,0,5.234,3.688c3.425,0,5.548-2.113,5.548-6.092V79.964H193.1a7.077,7.077,0,0,1-5.473,2.362,10.4,10.4,0,0,1,0-20.781,7.2,7.2,0,0,1,5.473,2.324h.159V62.177h4.334Zm-4.011,9.8c0-3.66-2.441-6.335-5.548-6.335-3.149,0-5.787,2.676-5.787,6.335a5.965,5.965,0,0,0,5.787,6.26C191.139,78.235,193.58,75.6,193.58,71.975Z",
    transform: "translate(-61.214 -42.749)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M214.062,46.985V77.443H209.61V46.985Z",
    transform: "translate(-70.539 -38.499)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M234.034,75.356l3.543,2.362a10.346,10.346,0,0,1-8.66,4.606A10.169,10.169,0,0,1,218.6,71.931c0-6.18,4.447-10.393,9.8-10.393,5.393,0,8.032,4.292,8.893,6.612l.474,1.181L223.88,75.084a5.289,5.289,0,0,0,5.037,3.149A5.932,5.932,0,0,0,234.034,75.356Zm-10.9-3.739,9.288-3.856a4.025,4.025,0,0,0-3.857-2.2A5.7,5.7,0,0,0,223.13,71.617Z",
    transform: "translate(-73.165 -42.747)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M83.606,64.495V60.085H98.464a14.619,14.619,0,0,1,.22,2.662c0,3.308-.9,7.4-3.819,10.313A14.757,14.757,0,0,1,83.61,77.587a16.14,16.14,0,1,1,0-32.276,15.377,15.377,0,0,1,11.059,4.447l-3.111,3.111a11.24,11.24,0,0,0-7.952-3.149,11.73,11.73,0,0,0,0,23.457,10.8,10.8,0,0,0,8.149-3.229,9.142,9.142,0,0,0,2.39-5.459Z",
    transform: "translate(-28.977 -38.01)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M21.119,36.819A1.819,1.819,0,0,1,22.938,35h9.825a1.819,1.819,0,0,1,1.819,1.819v9.825a1.819,1.819,0,0,1-1.819,1.819H22.938a1.819,1.819,0,0,1-1.819-1.819Zm3.275,1.274v6.823h6.823V38.093ZM20.982,77.484a3.411,3.411,0,1,1,3.412-3.411A3.411,3.411,0,0,1,20.982,77.484Zm13.646,0a3.411,3.411,0,1,1,3.411-3.411A3.411,3.411,0,0,1,34.628,77.484Z",
    transform: "translate(-14.478 -35)",
    fill: "#1967d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M36.674,46.178h-20.2A3.275,3.275,0,0,0,13.2,49.453V73.925A3.275,3.275,0,0,0,16.478,77.2h20.2a3.275,3.275,0,0,0,3.275-3.275V49.453A3.275,3.275,0,0,0,36.674,46.178Z",
    transform: "translate(-13.203 -38.263)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M13.2,50.379V74.85a3.279,3.279,0,0,0,.149.98L26.588,62.593,13.368,49.349A3.273,3.273,0,0,0,13.2,50.379Z",
    transform: "translate(-13.203 -39.189)",
    fill: "#fbbc04",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M26.636,61.734l.067-.067.067.067ZM13.483,48.423a3.277,3.277,0,0,1,3.109-2.246h20.2A3.276,3.276,0,0,1,39.9,48.442l-13.2,13.2Z",
    transform: "translate(-13.284 -38.263)",
    fill: "#ea4335",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M26.613,68.019l.067.067.067-.067ZM13.46,81.33a3.276,3.276,0,0,0,3.109,2.246h20.2a3.276,3.276,0,0,0,3.115-2.264l-13.2-13.2Z",
    transform: "translate(-13.278 -44.639)",
    fill: "#34a853",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M29.389,71.869a6.55,6.55,0,1,0-6.55-6.55A6.55,6.55,0,0,0,29.389,71.869Z",
    transform: "translate(-16.016 -41.939)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M36.862,63.492a8.94,8.94,0,0,1,.153,1.652c0,4.5-3.015,7.692-7.567,7.692a7.869,7.869,0,1,1,0-15.738,7.574,7.574,0,0,1,5.272,2.051L32.5,61.368v-.005a4.321,4.321,0,0,0-3.049-1.19,4.794,4.794,0,0,0,0,9.586,4.038,4.038,0,0,0,4.3-3.2h-4.3V63.492Z",
    transform: "translate(-15.644 -41.451)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBuss);
export default __webpack_public_path__ + "static/media/google-buss.76d0516c72b59cad42e68bfd5cc08b4c.svg";
export { ForwardRef as ReactComponent };